import { useMemo } from 'react';
import { createArrayIntentType } from '../../intent';
import { addRenderIntent, mergeProperty } from '../view';
import { configureRules, insertRule, mergeRules } from './core';
let createIntent;
const cssIntent = createArrayIntentType('deprecatedCss', (ci)=>{
    createIntent = ci;
    return {};
});
addRenderIntent(cssIntent, function useCssIntents(rules, props) {
    const rule = useMemo(()=>mergeRules(rules || []), [
        rules
    ]);
    if (rule) {
        insertRule(rule);
        mergeProperty(props, 'className', rule.classes);
    }
});
const globalCss = configureRules(undefined, {
    global: true
});
insertRule(globalCss`@layer reset, headless, theme, app;`);
/** @deprecated */ export function createCss(plugins, options = {
    layer: 'app'
}) {
    const create = configureRules(plugins, options, createIntent);
    const deprecatedCss = (...args)=>create(...args);
    deprecatedCss.plugins = plugins;
    const globalCss = create.options({
        global: true
    });
    deprecatedCss.global = (...args)=>globalCss(...args);
    const headless = create.options({
        layer: 'headless'
    });
    deprecatedCss.headless = (...args)=>headless(...args);
    const reset = create.options({
        layer: 'reset'
    });
    deprecatedCss.reset = (...args)=>reset(...args);
    const deprecatedOverride = create.options({
        layer: 'deprecatedOverride'
    });
    deprecatedCss.deprecatedOverride = (...args)=>deprecatedOverride(...args);
    return deprecatedCss;
}

//# sourceMappingURL=createCss.js.map